import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-warning mb-4 mx-auto",
  style: {"max-width":"1200px"},
  role: "alert"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "border-0" }
const _hoisted_7 = { class: "p-0" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = {
  key: 2,
  class: "row justify-content-center"
}
const _hoisted_13 = { class: "col-md-6 mb-4" }
const _hoisted_14 = {
  class: "card border-0 rounded-10 h-100",
  style: {"background-color":"#f8f9fa"}
}
const _hoisted_15 = { class: "card-body p-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_TaxDashboard = _resolveComponent("TaxDashboard")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Dashboard",
      subTitle: "Overview"
    }),
    (_ctx.showAlert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-error-warning-line fs-18 me-1" }, null, -1)),
          _createElementVNode("span", { innerHTML: _ctx.alertMessage }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center pb-20" }, null, -1)),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Caricamento...")
                  ], -1)
                ]))]))
              : (_ctx.lastCalculation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_TaxDashboard, {
                          lastCalculation: _ctx.lastCalculation,
                          hideTaxWidgets: _ctx.shouldHideTaxWidgets
                        }, null, 8, ["lastCalculation", "hideTaxWidgets"])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", {
                            class: "material-symbols-outlined text-primary mb-3",
                            style: {"font-size":"48px"}
                          }, "calculate", -1)),
                          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "fw-semibold mb-2" }, "Calcola Rata", -1)),
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-muted mb-3" }, "Calcola le tue tasse e pianifica i pagamenti", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/calcolo/forfettario",
                            class: "btn btn-primary"
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" Inizia Calcolo ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]))
          ])
        ])
      ])
    ])
  ]))
}